import veronica from "@/features/stepper/steptypes/veronica-look.png";
import darius from "@/features/stepper/steptypes/darius-look.png";
import { Badge } from "@/shared/components/ui/badge";
import { cn } from "@/shared/lib/utils";

const AVATAR_SIZE_CLASS = {
  sm: "size-7 text-xs",
  md: "size-10 text-xs",
  lg: "size-12 text-sm",
} as const;

/** Avatar and AI marker adapted from the Claude webchat reference. The host
 * has no shadcn avatar primitive, so this one is Tailwind-only. */
export function Avatar({
  name,
  ai = false,
  size = "md",
  className,
}: {
  name: string;
  ai?: boolean;
  size?: keyof typeof AVATAR_SIZE_CLASS;
  className?: string;
}) {
  const portrait = ai
    ? ({ veronica, darius } as Record<string, string>)[
        name.trim().toLowerCase()
      ]
    : undefined;
  const initials = name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();
  return (
    <span
      aria-hidden="true"
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded-full font-mono font-semibold select-none",
        AVATAR_SIZE_CLASS[size],
        ai
          ? "bg-accent/15 text-gold ring-1 ring-gold/60"
          : "bg-muted text-muted-foreground ring-1 ring-border",
        className,
      )}
    >
      {portrait ? (
        <img
          src={portrait}
          alt=""
          className="h-full w-full rounded-full object-cover object-top"
        />
      ) : (
        initials || "?"
      )}
    </span>
  );
}

export function AiChip({ rule }: { rule?: string | null }) {
  return (
    <Badge
      variant="outline"
      className="shrink-0 gap-1 rounded-xs border-gold/50 bg-accent/10 px-1 py-px font-mono text-[11px] leading-[1.3] font-semibold tracking-[0.05em] text-gold"
    >
      AI
      {rule && (
        <span className="font-normal text-gold-soft">
          {rule === "ALL_MESSAGES" ? " · all" : " · @ only"}
        </span>
      )}
    </Badge>
  );
}
